import React from "react";
import { Col, Row } from "react-bootstrap";
import {
  DiGit,
  DiJavascript1,
  DiMongodb,
  DiNodejs,
  DiReact,
} from "react-icons/di";
import {
  SiCouchbase,
  SiFastify,
  SiFirebase,
  SiGraphql,
  SiMaterialui,
  SiRedux,
  SiTypescript,
  // SiStyledComponents,
} from "react-icons/si";
import { AiOutlineAntDesign } from "react-icons/ai";

function Techstack() {
  return (
    <Row lg={{ cols: 5 }}
      style={{ justifyContent: "center", paddingBottom: "50px" }}
    >
      <Col xs={4} md={2} className="tech-icons">
        <DiJavascript1 />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiTypescript />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiReact />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiRedux />
      </Col>
      {/* <Col xs={4} md={2} className="tech-icons">
        <SiStyledComponents />
      </Col> */}
      <Col xs={4} md={2} className="tech-icons">
        <SiMaterialui />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <AiOutlineAntDesign />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiNodejs />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiMongodb />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiCouchbase />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiFastify />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiGraphql />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiGit />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiFirebase />
      </Col>
    </Row>
  );
}

export default Techstack;
